import { render, staticRenderFns } from "./requestDocument.vue?vue&type=template&id=2637377b"
import script from "./requestDocument.vue?vue&type=script&lang=js"
export * from "./requestDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports